import { UserTablePage } from "~/domain/common";

export function LqsUserTablePage() {
  return <UserTablePage />;
}
